import Swal from 'sweetalert2'
import { isNativeApp, nativePlugin } from '@/utils/nativeApp'
import { appDownloadUrl, formatAppSize, getAppRelease } from '@/services/wootdashAppRelease'

// Aviso de versão nova no app de celular: compara a versão instalada (App.getInfo, vem do ionic/package.json) com a
// publicada em Configurações Gerais › App de celular. Avisa uma vez por versão; o download abre no navegador do celular.

const DISMISSED_KEY = 'wootdash.app.versao-avisada'

/** -1, 0 ou 1 entre "1.2.3" e "1.10.0" (por número, não por texto). */
export function compareVersions(a: string, b: string): number {
  const pa = a.split('.').map(n => parseInt(n, 10) || 0)
  const pb = b.split('.').map(n => parseInt(n, 10) || 0)
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const diff = (pa[i] ?? 0) - (pb[i] ?? 0)
    if (diff !== 0) return diff > 0 ? 1 : -1
  }
  return 0
}

/** Chamar depois do login no app. Devolve se avisou. */
export async function checkNativeAppUpdate(): Promise<boolean> {
  if (!isNativeApp()) return false
  const installed = (await nativePlugin('App')?.getInfo?.().catch(() => null))?.version as string | undefined
  if (!installed) return false
  const release = await getAppRelease()
  if (!release || compareVersions(release.version, installed) <= 0) return false
  try { if (localStorage.getItem(DISMISSED_KEY) === release.version) return false } catch { /* sem storage: avisa */ }
  if (Swal.isVisible()) return false // outra pergunta na tela (ex.: ativar a digital): avisa na próxima abertura
  try { localStorage.setItem(DISMISSED_KEY, release.version) } catch { /* modo privado */ }

  const notes = release.notes ? `<p style="margin:10px 0 0;font-size:13px;color:#4b5563"><b>Novidades:</b> ${escapeHtml(release.notes)}</p>` : ''
  const answer = await Swal.fire({
    icon: 'info',
    title: 'Nova versão do app',
    html: `A versão <b>${escapeHtml(release.version)}</b> (${formatAppSize(release.sizeBytes)}) está disponível — você está com a ${escapeHtml(installed)}.${notes}<p style="margin:10px 0 0;font-size:12.5px;color:#6b7280">Baixe e toque no arquivo pra instalar por cima; não precisa desinstalar.</p>`,
    showCancelButton: true, confirmButtonText: 'Baixar agora', cancelButtonText: 'Depois', confirmButtonColor: '#bc0c24',
  })
  if (answer.isConfirmed) await openDownload()
  return true
}

/** Abre o download no navegador do celular (o WebView do app não baixa arquivos). */
export async function openDownload(): Promise<void> {
  const url = appDownloadUrl()
  const openUrl = nativePlugin('WootDashCall')?.openUrl
  if (openUrl) {
    await openUrl({ url }).catch(() => undefined)
    return
  }
  // App antigo, sem o atalho: mostra o endereço pra abrir no navegador.
  void Swal.fire({ icon: 'info', title: 'Baixe pelo navegador', html: `Abra no navegador do celular:<br><b style="word-break:break-all">${escapeHtml(url)}</b>` })
}

function escapeHtml(text: string): string {
  return text.replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]!))
}
